import React, {FC} from 'react'
import styles from './HospitalityTabs.module.css'

export interface TabItem {
  id: string
  label: string
  icon?: string
  content: React.ReactNode
  hasError?: boolean
}

interface HospitalityTabsProps {
  tabs: TabItem[]
  activeTab: string
  onTabChange: (tabId: string) => void
  className?: string
}

export const HospitalityTabs: FC<HospitalityTabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
}) => {
  const getTabClass = (tab: TabItem, isActive: boolean) => {
    const baseClass = styles.tabItem

    if (tab.hasError) {
      return `${baseClass} ${styles.tabError} ${isActive ? 'active' : ''}`
    }

    return `${baseClass} ${isActive ? styles.tabActive : styles.tabInactive}`
  }

  const activeTabContent = tabs.find((tab) => tab.id === activeTab)?.content

  return (
    <div className={className}>
      {/* Tabs Menu */}
      <div className='d-flex justify-content-between'>
        <div className={`d-flex ${styles.tabMenu}`}>
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className={getTabClass(tab, activeTab === tab.id)}
              onClick={() => onTabChange(tab.id)}
            >
              {tab.icon && <i className={`${tab.icon} me-2`}></i>}
              {tab.label}
            </div>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className='mt-5'>{activeTabContent}</div>
    </div>
  )
}
